<template>
  <b-sidebar
    id="drawer-approver-final-global"
    :visible="visible"
    title="Atur Approval Final"
    backdrop-variant="dark"
    backdrop
    right
    shadow
    width="520px"
    sidebar-class="right-drawer"
    aria-hidden="false"
    @hidden="onClose"
  >
    <div class="p-[1.5rem] flex flex-col justify-between min-h-[calc(100vh-80px)]">
      <div>
        <!-- Subtitle -->
        <div class="text-sm text-[#828282] mb-[1.5rem]">
          Saat ini menjabat:
        </div>
        <!-- Approver Final (Otomatis) Card -->
        <div class="relative z-10 flex items-start gap-[1rem]">
          <!-- Check Icon: patch-check-fill from vue bootstrap icon -->
          <div class="size-[42px] rounded-full flex items-center justify-center shrink-0 mt-[.25rem] bg-[#F95E16]">
            <BIcon
              icon="patch-check"
              class="text-primary bg-white rounded-full"
              font-scale="1.5"
            />
          </div>
          <div class="bg-[#FFF8F6] border-solid border-[1px] border-[#FFD0B5] rounded-2xl p-[1rem] flex-1">
            <span class="text-xs font-semibold text-black mb-[.5rem]">Approver Final</span>
            <div class="bg-white rounded-lg">
              <v-select
                v-model="selectedApprover"
                :options="employeeOptions"
                :loading="isLoadingStaff"
                :filterable="false"
                label="name"
                placeholder="Pilih atau cari karyawan"
                class="custom-employee-select"
                @search="onSearchStaff"
              >
                <template #selected-option="option">
                  <div class="inline-flex items-center gap-[.5rem] py-[.125rem]">
                    <div>
                      <div class="text-sm font-medium text-black leading-tight">
                        {{ option.name }} <span
                          v-if="option.npk"
                          class="text-xs text-[#94A3B8] font-normal"
                        >({{ option.npk }})</span>
                      </div>
                      <div class="text-xs text-[#828282] leading-tight">
                        {{ option.role }}{{ option.division ? ` • ${option.division}` : '' }}
                      </div>
                    </div>
                  </div>
                </template>
                <template #option="option">
                  <div
                    class="flex items-center gap-[.5rem] p-[.25rem] hover:cursor-pointer hover:bg-slate-50 rounded-lg"
                  >
                    <div class="w-[28px] h-[28px] rounded-lg bg-[#F1F5F9] text-[#64748B] text-[10px] font-semibold flex items-center justify-center shrink-0">
                      {{ option.initials || (option.name ? option.name.substring(0, 2).toUpperCase() : '') }}
                    </div>
                    <div>
                      <div class="text-xs font-medium text-black">
                        {{ option.name }} <span
                          v-if="option.npk"
                          class="text-[11px] text-[#94A3B8] font-normal"
                        >({{ option.npk }})</span>
                      </div>
                      <div class="text-[11px] text-[#828282]">
                        {{ option.role }}{{ option.division ? ` • ${option.division}` : '' }}
                      </div>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </div>

      </div>

      <!-- Action Buttons Footer -->
      <div class="mt-[2rem]">
        <div
          v-if="globalData && !globalData.isNotSet && (globalData.id || globalData.user_id)"
          class="mb-[1rem] flex justify-center"
        >
          <BButton
            variant="link"
            size="sm"
            class="!text-[#DC2626] hover:!text-[#B91C1C] p-0 !flex items-center gap-[.35rem]"
            :disabled="isSubmitting"
            @click="handleDelete"
          >
            <span class="k-trash text-[16px] text-[#DC2626]" />
            <span class="text-xs font-medium">Hapus Approver Final Global</span>
          </BButton>
        </div>
        <div class="flex items-between gap-[1rem]">
          <BButton
            size="md"
            variant="outline-primary"
            block
            :disabled="isSubmitting"
            @click="onClose"
          >
            Batalkan
          </BButton>
          <BButton
            size="md"
            variant="primary"
            block
            class="m-0 !flex items-center justify-center gap-1"
            :disabled="!selectedApprover || isSubmitting"
            @click="handleSave"
          >
            <BSpinner
              v-if="isSubmitting"
              small
              class="mr-1"
            />
            <span>Simpan Perubahan</span>
          </BButton>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<style scoped>
::v-deep .b-sidebar-header,
::v-deep .b-sidebar-body {
  background-color: white;
}

::v-deep .custom-employee-select .vs__dropdown-toggle {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  min-height: 48px;
  padding: 4px 8px;
}

::v-deep .custom-employee-select .vs__selected {
  margin: 2px;
}

::v-deep .custom-employee-select .vs__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-left: auto;
  padding: 0;
  height: 100%;
}

::v-deep .custom-employee-select .vs__dropdown-toggle {
  display: flex;
  align-items: center;
}

::v-deep .vs__search:focus {
  outline: none;
}

::v-deep .btn-outline-primary,
::v-deep .btn-primary {
  border-radius: 10px;
}
</style>

<script>
import vSelect from 'vue-select'
import { searchApproverUsers } from '../config'
import { employeeOptions as defaultEmployeeOptions } from '../mockData'

export default {
  name: 'DrawerApproverFinalGlobal',
  components: {
    vSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    globalData: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      employeeOptions: [],
      isLoadingStaff: false,
      searchTimer: null,
      selectedApprover: null,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchStaffOptions('')
        this.initSelected()
      }
    },
    globalData: {
      deep: true,
      handler() {
        if (this.visible) {
          this.initSelected()
        }
      },
    },
  },
  mounted() {
    this.fetchStaffOptions('')
  },
  methods: {
    initSelected() {
      if (
        this.globalData
        && !this.globalData.isNotSet
        && (this.globalData.user_id || this.globalData.id)
        && this.globalData.approverFinal !== 'Belum diatur'
      ) {
        const userId = this.globalData.user_id || this.globalData.id
        const found = this.employeeOptions.find(
          e => e.id === userId || e.name === this.globalData.approverFinal,
        )
        this.selectedApprover = found || {
          id: userId,
          name: this.globalData.approverFinal,
          role: this.globalData.approverFinalRole || 'Finance',
          initials: (this.globalData.approverFinal || '').substring(0, 2).toUpperCase(),
        }
      } else {
        this.selectedApprover = null
      }
    },
    onClose() {
      this.$emit('on-close')
    },
    handleSave() {
      this.$emit('on-save', this.selectedApprover)
    },
    handleDelete() {
      this.$emit('on-delete', this.globalData)
    },
    onSearchStaff(search) {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.fetchStaffOptions(search || '')
      }, 400)
    },
    async fetchStaffOptions(keyword = '') {
      this.isLoadingStaff = true
      try {
        const list = await searchApproverUsers(keyword)
        if (Array.isArray(list)) {
          const map = new Map()
          if (this.selectedApprover && this.selectedApprover.id) {
            map.set(this.selectedApprover.id, this.selectedApprover)
          }
          list.forEach(item => map.set(item.id, item))
          this.employeeOptions = Array.from(map.values())

          if (this.selectedApprover && (this.selectedApprover.id || this.selectedApprover.user_id)) {
            const currentId = this.selectedApprover.id || this.selectedApprover.user_id
            const found = this.employeeOptions.find(e => e.id === currentId)
            if (found) {
              this.selectedApprover = found
            }
          }
        }
      } catch (error) {
        // Fallback
      } finally {
        this.isLoadingStaff = false
      }
    },
  },
}
</script>
